module.exports = __webpack_public_path__ + "media/images/icon__minus@3x-4fe507966e5bc3f7d7ae3872b9c5be94.png";